/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { Component } from 'react';
import {
  FileUploader as ConsumerFileUploader,
  FileUploaderProps as ConsumerFileUploaderProps,
} from '@blend/consumer-components';

export default class FileUploader extends Component<ConsumerFileUploaderProps> {
  render() {
    const { children, ...fileUploaderProps } = this.props;
    return <ConsumerFileUploader {...fileUploaderProps}>{children}</ConsumerFileUploader>;
  }
}
